'use client'

import { ArrowLeft } from "lucide-react"
import { Button } from "@/components/ui/button"
import { useRouter } from "next/navigation"
import { ArrowRight } from "lucide-react"
import { useLocale, useTranslations } from "next-intl"
import { localeMetadata, routing, type AppLocale } from "@/i18n/routing"

export function BackButton() {
  const router = useRouter()
  const locale = useLocale()
  const t = useTranslations("page.error")
  const currentLocale =
    localeMetadata[locale as AppLocale] ??
    localeMetadata[routing.defaultLocale as AppLocale]

  return (
    <Button 
      variant="ghost" 
      onClick={() => router.back()} 
      className="text-teal-600 hover:bg-teal-50"
    >
      {currentLocale.isRtl ? (
        <ArrowRight className="me-2 h-4 w-4" />
      ) : (
        <ArrowLeft className="me-2 h-4 w-4" />
      )}
      {t("back_button")}
    </Button>
  )
}
